<!-- 项目计划 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch"
      >
        <template v-slot:next>
          <el-button icon="el-icon-plus" v-if="!isAdmin" @click="add()">新增</el-button>
          <el-button icon="el-icon-upload2" @click="downloadExcel()">导出</el-button>
          <el-popover placement="bottom" trigger="click" v-if="false">
            <label style="color:red;font-size: 0.75rem;">
              温馨提示：若项目计划已经存在，再次导入会根据项目号+节点编号进行覆盖更新
            </label>
            <el-upload
              class="upload-demo"
              ref="upload"
              action=""
              :before-upload="beforeUpload"
              :show-file-list="true"
              :file-list="fileList"
              :limit="1"
              :auto-upload="false">

              <el-button slot="trigger" size="mini" type="" class="el-button--warning link-left">选取文件</el-button>
              <el-button @click="submitUpload" type="primary" size="mini" :loading="uploadLoading" class=" link-left">导入</el-button>
              <el-button size="mini" class="el-button--goon">
                <a href="static/template.xls" download="template.xls">下载导入模版</a>
                </el-button>
        </el-upload>
          <el-button slot="reference" style="margin-left:10px;" icon="el-icon-upload2" type="primary">导入</el-button>
        </el-popover>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data="list"
        :editable="false"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
            <el-button type="text" size="mini" icon="el-icon-view" @click="view(scope.row)"></el-button>
          <template v-if="scope.row.possess === 2">
            <el-button type="text" icon="el-icon-edit" v-if="(statusEdit(scope.row.billState) || scope.row.billState === 3)" @click="edit(scope.row)"></el-button>
            <el-popover :ref="scope.row.id" placement="top" width="180" v-if="statusEdit(scope.row.billState)">
              <p>确定删除本条数据吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                <el-button
                  :loading="loading"
                  type="primary"
                  size="mini"
                  @click="del(scope.row.id)"
                >确定</el-button>
              </div>
              <el-button
                type="text"
                size="mini"
                icon="el-icon-delete"
                slot="reference"
              ></el-button>
            </el-popover>
          </template>
           <!-- <el-button type="text" v-if="(statusEdit(scope.row.billState) || scope.row.billState === 3 )" @click="adjustment(scope.row)">调整</el-button> -->
           <!-- <el-popover :ref="scope.row.id" placement="top" width="220" v-if="scope.row.billState === 2">
            <p>确定退回该项目计划吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row)">退回</el-button>
              &lt;!&ndash; <el-button type="primary" size="mini" @click="audit(scope.row)">确定</el-button> &ndash;&gt;
            </div>
            &lt;!&ndash; <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button> &ndash;&gt;
          </el-popover>-->
        <!--  <el-popover
            :ref="scope.row.id"
            placement="top"
            width="180"
             v-if="statusUnAudit(scope.row.billState) && scope.row.possess !== 1"
          >
            <p>确定反审核该项目计划单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row, 5)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover>-->
        </template>
      </edit-data-table>
    </el-card>
    <!-- <drag-dialog :show.sync="dialog" title="导出" width="600px" enableDrag>
      <div class="text-date">
        <span>任务时间</span>
        <el-date-picker
          v-model="taskTime"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          value-format="yyyy-MM"
          end-placeholder="结束月份">
        </el-date-picker>
      </div>
      <div class="submit-btn">
        <el-button type="primary" @click="submitFile" :loading="loading">确认</el-button>
        <el-button type="primary" @click="cancelFile" :loading="loading">取消</el-button>
      </div>
    </drag-dialog> -->
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { deletePlanById,addPlan,downloadExcel, importExcel } from "@/api/bill/ProjectPlan";
import {tableSataus} from '@/views/bill/mixins/status'
// import DragDialog from '@/components/DragDialog'
export default {
  name: "ProjectPlanIndex",
  mixins: [DataTableMixin,tableSataus],
  components: {
    DynamicSearch,
   // DragDialog
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  data() {
    return {
      uploadLoading: false,
      fileList: [],
      total: 1,
      tableHead: [
        {
          label: "单据编号",
          prop: "documentNum",
          align: "center"
        },
         {
          label: "项目名",
          prop: "projectName",
          align: "center",
          query: {
            type: "input"
          },
        },
        {
          label: "项目号",
          prop: "projectNum",
          query: {
            type: "input"
          },
          align: "center"
        },
        {
          label: "提交日期",
          prop: "planDate",
          align: "center"
        },
        {
          label: "终端客户",
          prop: "customerMain",
          align: "center",
          formatter: (cellVal, row) => {
            if (row && row.project && row.project.customer) {
              return row.project.customer.name
            } return ''
          }
        },
        // {
        //   label: "最后修改日期",
        //   prop: "modified",
        //   align: "center"
        // },
        {
          label: "状态",
          prop: "billState",
          formatter: (state) => {
            return this.statusName(state)
          }
        }
      ],
      tableData: [],
      dialog: false,
      taskTime: null,
    };
  },
  methods: {
    submitUpload() {
      this.uploadLoading = true;
      const that = this
      setTimeout(function() {
        if (that.$refs.upload.$children[0].fileList.length === 1) {
          that.$refs.upload.submit();
        } else {
          that.uploadLoading = false;
          that.$message({
            type: 'error',
            showClose: true,
            duration: 3000,
            message: '请选择文件后，在进行导入哦!'
          });
        }
      },100);
    },
    beforeUpload(file) {
      const that = this
      // 文件类型
      const fileName = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (fileName !== 'xls' && fileName !== 'xlsx') {
        that.uploadLoading = false;
        that.$message({
          type: 'error',
          showClose: true,
          duration: 3000,
          message: '文件类型不是.xls'
        });
        return false;
      }
      that.downloadLoading = that.$loading({
        lock: true,
        text: '数据导入中...,请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.7)'
      });
      const fd = new FormData();
      fd.append('file',file);
      fd.append('_t1',new Date());
                importExcel(fd).then(resp => {
                  console.log(resp);
                    that.downloadLoading.close();
                    that.uploadLoading = false;
                    if (resp.data.code === 200) {
                        that.uploadTemplateDialog = false;
                        that.$message.success(resp.data.msg);
                        location.reload();
                    } else {
                      console.log("test========");
                        that.uploadTemplateDialog = false;
                        that.$message({
                            type: 'error',
                            showClose: true,
                            duration: 60000,
                            message: resp.data.msg
                        });
                    }
                })
    },
    // 导出
    downloadExcel() {
      downloadExcel('/biz-project-plan/get/excel',this._query,'项目计划')
    },
    // submitFile() {
    //   console.log(this.taskTime.join());
    //   this._query.taskTime = this.taskTime.join()
    //   downloadExcel('/biz-project-plan/get/excel',this._query,'项目计划')
    // },
    // cancelFile() {
    //   this.dialog = false
    // },
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/biz-project-plan/getList`;
      const params = { page: this.page, size: this.offset, };
      this._params = Object.assign(params, this._query);
      return true;
    },
    add() {
      this.$router.push({ path: "ProjectPlan/newPlan", query: {isEdit: 1} });
    },
    view(data) {
      this.$router.push({ path: "ProjectPlan/newPlan", query: { id: data.id ,isEdit: 0} });
    },
     // 修改
    edit(data) {
      this.$router.push({ path: "ProjectPlan/newPlan", query: { id: data.id ,isEdit: 1} });
    },
    // adjustment(data) {
    //   this.$router.push({ path: "ProjectPlan/newPlan", query: { id: data.id ,isEdit: 1} });
    // },
   audit(data) { // 审核
      data.bizProjectPlan = {id: data.id,billState: 3}
      this.updata(data);
       this.$nextTick(() => {
        this.$refs[data.id].doClose()
      })
    },

    // 4回退 5 反审核
    reject(data, status = 4) {
       data.bizProjectPlan = {id: data.id, billState: status}
      this.updata(data);
       this.$nextTick(() => {
        this.$refs[data.id].doClose()
      })
    },
      updata(data) {
		addPlan(data).then(res => {
			console.log(res);
			if (res.code === 200) {
			this.$notify({
				title: '操作成功',
				type: "success",
				duration: 2500
			});
			this.dataTableInit();
			}
		});
    },
    // 删除
    del(id) {
      if (id) {
        this.loading = true;
        deletePlanById(id).then(res => {
          if (res.code === 200) {
            this.loading = false;
            this.$notify({
              title: '删除成功',
              type: 'success',
              duration: 2500
            })
            this.$nextTick(() => {
              this.dataTableInit();
            });
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  height: 100%;
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
.text-date{
  text-align: center;
  padding-bottom: 20px;
}
.submit-btn{
  text-align: center;
}
@media (max-width: 1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
.el-upload-list__item{
  width:100% !important;
}
</style>
